module.exports = __webpack_public_path__ + "img/hidelike-logo-quer-mit-slogan.2700aa40.svg";